
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/oauth",
      function () {
        return require("private-next-pages/docs/errors/oauth.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/oauth"])
      });
    }
  